var map = {
	"./template.bet575": 1634,
	"./template.bet575.tsx": 1634,
	"./template.bet777": 1635,
	"./template.bet777.tsx": 1635,
	"./template.betprofessor": 1636,
	"./template.betprofessor.tsx": 1636,
	"./template.betroyale": 1637,
	"./template.betroyale.tsx": 1637,
	"./template.buffalobet": 1638,
	"./template.buffalobet.tsx": 1638,
	"./template.chromabet": 1639,
	"./template.chromabet.tsx": 1639,
	"./template.default": 675,
	"./template.default.tsx": 675,
	"./template.epicodds": 1640,
	"./template.epicodds.tsx": 1640,
	"./template.fiestabet": 1641,
	"./template.fiestabet.tsx": 1641,
	"./template.gigabet": 1642,
	"./template.gigabet.tsx": 1642,
	"./template.goldenbet888": 1643,
	"./template.goldenbet888.tsx": 1643,
	"./template.goldenrush": 1644,
	"./template.goldenrush.tsx": 1644,
	"./template.hyperbet": 1645,
	"./template.hyperbet.tsx": 1645,
	"./template.juicybet": 1646,
	"./template.juicybet.tsx": 1646,
	"./template.junglebet": 1647,
	"./template.junglebet.tsx": 1647,
	"./template.magnumbet": 1648,
	"./template.magnumbet.tsx": 1648,
	"./template.oldgill": 1649,
	"./template.oldgill.tsx": 1649,
	"./template.puntcity": 1650,
	"./template.puntcity.tsx": 1650,
	"./template.puntgenie": 1651,
	"./template.puntgenie.tsx": 1651,
	"./template.pyramidbet": 1652,
	"./template.pyramidbet.tsx": 1652,
	"./template.questbet": 1653,
	"./template.questbet.tsx": 1653,
	"./template.slambet": 1654,
	"./template.slambet.tsx": 1654,
	"./template.sterlingparker": 1655,
	"./template.sterlingparker.tsx": 1655,
	"./template.sugarcastle": 1656,
	"./template.sugarcastle.tsx": 1656,
	"./template.templebet": 1657,
	"./template.templebet.tsx": 1657,
	"./template.titanbet": 1658,
	"./template.titanbet.tsx": 1658,
	"./template.ts": 989,
	"./template.vikingbet": 1659,
	"./template.vikingbet.tsx": 1659,
	"./template.volcanobet": 1660,
	"./template.volcanobet.tsx": 1660,
	"./template.wellbet": 1661,
	"./template.wellbet.tsx": 1661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2469;